<script lang="ts">
    import {getInjector} from 'src/core';
    import {ErpFondPermissionsContextService, type FondPermissions} from 'src/features/erp';
    import {onDestroy} from 'svelte';
    import {cleanup, exists} from 'shared/utils/custom-utils';

    export let showableFondId: number | number[] | null = null;
    export let editableFondId: number | number[] | null = null;
    export let checkType: 'has-some' | 'has-all' = 'has-all';

    const fondPermissionsService = getInjector().getByClass(ErpFondPermissionsContextService);

    let fondPermissions: FondPermissions;
    const fondPermissionsSubscription = fondPermissionsService.fondPermissions$.subscribe((currentFondPermissions) => fondPermissions = currentFondPermissions);

    onDestroy(() => {
        cleanup(fondPermissionsSubscription);
    });

    function hasFondPermissions(permissions: FondPermissions): boolean {
        const showableFonds = Array.isArray(showableFondId) ? showableFondId : [showableFondId].filter((id) => exists(id));
        const editableFonds = Array.isArray(editableFondId) ? editableFondId : [editableFondId].filter((id) => exists(id));

        const hasAllShowableFondPermissions = showableFonds.length === 0 || showableFonds.every((fondId) => permissions.showable.includes(fondId));
        const hasAllEditableFondPermissions = editableFonds.length === 0 || editableFonds.every((fondId) => permissions.editable.includes(fondId));

        const hasSomeShowableFondPermissions = showableFonds.some((fondId) => permissions.showable.includes(fondId));
        const hasSomeEditableFondPermissions = editableFonds.some((fondId) => permissions.editable.includes(fondId));

        return checkType === 'has-all'
            ? hasAllShowableFondPermissions && hasAllEditableFondPermissions
            : hasSomeShowableFondPermissions || hasSomeEditableFondPermissions;
    }
</script>

{#if hasFondPermissions(fondPermissions)}
    <slot/>
{/if}